import { Module } from "vuex";
import { RootState } from "../types";
import { actions } from "./actions";
import { getters } from "./getters";
import { mutations } from "./mutations";
import { AnalyseState } from "./types";
import moment from "moment/moment";

export const state: AnalyseState = {
  userId: localStorage.user ? JSON.parse(localStorage.user).id : "",
  dateFiscale: moment().format("YYYY-MM-DD"),
};

const namespaced: boolean = true;

export const analyses: Module<AnalyseState, RootState> = {
  namespaced,
  state,
  getters,
  actions,
  mutations,
};
